export enum AccessType {
    'LQAAdmin' = 'LQAAdmin',
    'LQABasic' = 'LQABasic',
    'masterClientUser' = 'masterClientUser',
    'clientUser' = 'clientUser',
    'brandClientUser' = 'brandClientUser',
    'regionalClientUser' = 'regionalClientUser',
    'hotelUser' = 'hotelUser',
}
